const LABEL_OVERRIDES = {
  dropdown_input_missing: 'Search dropdown unavailable',
  ERR_CANNOT_BUILD_EMBEDDINGS: 'Image processing failed',
  ERR_EMBEDDINGS_EXPIRED: 'Image upload session expired',
  ERR_MISSING_TOKEN: 'Authentication required',
  ERR_NETWORK_ERROR: 'Network connection error',
  ERR_SEARCH_FAILED: 'Search request failed',
  ERR_SERVER_ERROR: 'Server unavailable',
  ERR_TIMEOUT: 'Request timed out',
  ERR_VISUAL_SEARCH_DISABLED: 'Visual search disabled',
  ERR_VISUAL_SEARCH_FAILED: 'Visual search failed',
  FALLBACK_OR: 'Alternative option separator',
  IMAGE_LOAD_ERROR: 'Image loading failed',
  IMAGE_NOT_SELECTED: 'No image selected',
  INVALID_IMAGE_TYPE: 'Unsupported image format',
  INVALID_URL: 'Invalid image URL',
  NO_SEARCHBOX_CREATED: 'Search box unavailable',
  UNEXPECTED_ERROR: 'Unexpected error',
  WARN_VOICE_NO_SPEECH: 'No speech detected',
  WARN_VOICE_NOT_SUPPORTED: 'Voice search unsupported',
  WARN_VOICE_RESTRICTED: 'Voice search permission required',
  results_selector_missing: 'Results area selector missing',
  results_target_missing: 'Results area unavailable',
  runtime_execution_error: 'Search interface runtime error',
  runtime_expected_not_mounted: 'Search interface did not start',
  search_input_missing: 'Search field unavailable',
  localizeProductCartAdd: 'Add to cart button',
  localizeProductCartAdded: 'Added to cart status',
  localizeProductCartAdding: 'Adding to cart status',
  localizeProductCartError: 'Add to cart error',
  localizeProductQuickView: 'Quick view button',
  localizeProductUnavailable: 'Unavailable product status',
  localizeProductWishlistAdd: 'Add to wishlist button',
  localizeSearchInputPlaceholder: 'Search field placeholder',
  localizeTextInputPlaceholder: 'Search field placeholder',
  localizeVisualInputPlaceholder: 'Visual search field placeholder',
  localizeVisualInputPlaceholderEmpty: 'Empty visual search placeholder',
};

const DESCRIPTION_OVERRIDES = {
  dropdown_input_missing: 'Shown when the configured dropdown search field cannot be found.',
  ERR_CANNOT_BUILD_EMBEDDINGS: 'Shown when visual search cannot process an uploaded image.',
  ERR_EMBEDDINGS_EXPIRED: 'Shown when an image upload must be started again.',
  ERR_MISSING_TOKEN: 'Shown when the shopper needs to refresh their authentication.',
  ERR_NETWORK_ERROR: 'Shown when the storefront cannot reach the search service.',
  ERR_SEARCH_FAILED: 'Shown when a search request cannot be completed.',
  ERR_SERVER_ERROR: 'Shown when the search service returns a server error.',
  ERR_TIMEOUT: 'Shown when a search request takes too long.',
  ERR_VISUAL_SEARCH_DISABLED: 'Shown when visual search is not available for the shop.',
  ERR_VISUAL_SEARCH_FAILED: 'Shown when a visual search request cannot be completed.',
};

function humanizeKey(key) {
  const words = String(key)
    .replace(/^(ERR_|WARN_)/, '')
    .replace(/^(localize|localized|localization|preview)/, '')
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2')
    .replace(/[_-]+/g, ' ')
    .trim()
    .toLowerCase();

  if (!words) return 'Storefront message';
  return `${words.charAt(0).toUpperCase()}${words.slice(1)}`;
}

function describeKey(key) {
  if (/^(ERR_|UNEXPECTED_ERROR|runtime_execution_error)/.test(key)) {
    return 'Error message shown to shoppers when this problem occurs.';
  }
  if (/^WARN_/.test(key)) {
    return 'Warning shown to shoppers while they use voice search.';
  }
  if (/^preview/.test(key) || /^(dropdown_|results_|runtime_|search_input_)/.test(key)) {
    return 'Text shown in the storefront preview and integration checks.';
  }
  if (/Image|Visual|IMAGE|INVALID_(IMAGE|URL)/.test(key)) {
    return 'Text shown while shoppers use visual search.';
  }
  if (/Facet|Filter/.test(key)) {
    return 'Text shown in storefront filters.';
  }
  if (/Sort|ShowBy|ShowingProducts/.test(key)) {
    return 'Text shown in product sorting and result controls.';
  }
  if (/Product|VendorCode|Label(New|Sale)/.test(key)) {
    return 'Text shown on storefront product cards.';
  }
  if (/SearchBox|DidYouMean|Searched|NothingFound|MoreProducts/.test(key)) {
    return 'Text shown in search suggestions and results.';
  }
  if (/Mobile/.test(key)) {
    return 'Text shown in the mobile search experience.';
  }
  if (/Section|History/.test(key)) {
    return 'Heading or action shown in the search experience.';
  }
  return 'Text shown to shoppers in the storefront search interface.';
}

export function getTranslationPresentation(key) {
  return {
    label: LABEL_OVERRIDES[key] || humanizeKey(key),
    description: DESCRIPTION_OVERRIDES[key] || describeKey(key),
  };
}

